import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Value from '~/views/Home/base/Value';

export default class HeaderScoresRun extends Component {
  static propTypes = {
    scoreBox: PropTypes.shape({
      backgroundColor: PropTypes.string,
      borderColor: PropTypes.string,
      color: PropTypes.string,
    }).isRequired,
    scoreBoxHighlight: PropTypes.shape({
      backgroundColor: PropTypes.string,
      borderColor: PropTypes.string,
      color: PropTypes.string,
    }).isRequired,
    scoreBoxDrop: PropTypes.shape({
      backgroundColor: PropTypes.string,
      borderColor: PropTypes.string,
      color: PropTypes.string,
    }).isRequired,
    run: PropTypes.shape({
      highlight: PropTypes.any,
      drop: PropTypes.any,
      rank: PropTypes.any,
    }).isRequired,
  };

  render() {
    const { scoreBox, scoreBoxHighlight, scoreBoxDrop, run } = this.props;

    let style = run.highlight ? scoreBoxHighlight : scoreBox;

    if (run.drop) {
      style = scoreBoxDrop;
    }

    return (
      <div className="run" style={style}>
        <Value>{run.rank}</Value>
      </div>
    );
  }
}
